export class GameFlowEvents {
	public static readonly HAS_WIN_SYMBOLS_TO_HIGHLIGHT: string = 'GameFlowEvents::HAS_WIN_SYMBOLS_TO_HIGHLIGHT';

	public static readonly HAS_WIN_WITH_MULTIPLIER: string = 'GameFlowEvents::HAS_WIN_WITH_MULTIPLIER';
	public static readonly HAS_BIGWIN_WITH_MULTIPLIER: string = 'GameFlowEvents::HAS_BIGWIN_WITH_MULTIPLIER';
	public static readonly HAS_WIN_WITH_NO_MULTIPLIER: string = 'GameFlowEvents::HAS_WIN_WITH_NO_MULTIPLIER';
	public static readonly HAS_BIGWIN_WITH_NO_MULTIPLIER: string = 'GameFlowEvents::HAS_BIGWIN_WITH_NO_MULTIPLIER';
	public static readonly PLAY_FREE_SPINS_TRIGGER: string = 'GameFlowEvents::PLAY_FREE_SPINS_TRIGGER';
}



// WEBPACK FOOTER //
// ./src/flow/GameFlowEvents.ts